
import Vue from 'vue';
import Component from 'vue-class-component';
import { Ref } from 'vue-property-decorator';
import { validators } from '@/utils/validations';
import NavBar from '@/components/NavBar';
import ContactUsApi from '@/api/contact-us.api';
import { ContactUsModel } from '@/models/contact-us.model';

@Component({
  components: {
    NavBar
  },
  metaInfo() {
    return {
      title: 'Ikone'
    };
  },
})
export default class ContactUsPage extends Vue {
  valid: boolean = false;
  name: string = '';
  email: string = '';
  subject: string = '';
  body: string = '';
  snackbarVisibility = false;
  loadingEmail: boolean = false;
  snackbarColor: 'green' | 'red' = 'green';
  snackbarText = '';
  @Ref('form') form: any;
  rules = validators;

  async sendEmail() {
    this.loadingEmail = true;

    // @ts-ignore
    if (!this.form.validate()) {
      this.loadingEmail = false;
      return;
    }

    const data: ContactUsModel = {
      name: this.name,
      email: this.email,
      subject: this.subject,
      message: this.body
    };

    try {
      await new ContactUsApi().sendContactEmail(data);
      this.snackbarMessage('contact.email.success', 'green');
      this.loadingEmail = false;
    } catch (e) {
      this.snackbarMessage('contact.email.failed', 'red');
      this.loadingEmail = false;
    }
    this.resetForm();
  }

  resetForm() {
    this.name = '';
    this.email = '';
    this.subject = '';
    this.body = '';
    // @ts-ignore
    this.form.reset();
  }

  private snackbarMessage(message: string, color: 'green' | 'red') {
    this.snackbarColor = color;
    this.snackbarText = message;
    this.snackbarVisibility = true;
  }
}
